import { createContext, use } from 'react';

/**
 * Section 17's re-check, as a contract. The provider and the dialog live in
 * `reauth.tsx`; this is what the rest of the console imports.
 */

export interface ReauthContextValue {
  /**
   * Resolves true when the gate is open and the action may go ahead, false when
   * the person cancelled. Never rejects: a cancelled confirmation is an answer, not
   * a failure.
   */
  ensureReauthenticated: () => Promise<boolean>;
}

export const ReauthContext = createContext<ReauthContextValue | null>(null);

export function useReauth(): ReauthContextValue {
  const context = use(ReauthContext);
  if (context === null) throw new Error('useReauth must be used inside a ReauthProvider');
  return context;
}
